import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// When a write request is blocked by the subscription guard, the backend
// returns 403 with detail = { code: "trial_expired"|"payment_open"|"suspended", message }.
// We dispatch a single global event so a top-level component can render the notice.
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    if (status === 403 && detail && typeof detail === "object" && detail.code) {
      const blocked = ["trial_expired", "payment_open", "suspended"];
      if (blocked.includes(detail.code)) {
        window.dispatchEvent(new CustomEvent("sonara:subscription-blocked", {
          detail: { code: detail.code, message: detail.message },
        }));
      }
    }
    return Promise.reject(error);
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export default api;
